@if (renderItem) {
	@if (!menuitem.subMenu) {
		<mat-accordion>
			<mat-expansion-panel
				hideToggle
				[ngStyle]="style"
				class="mat-elevation-z0"
				[expanded]="open"
			>
				@if (!menuitem.javaSite) {
					<mat-expansion-panel-header
						#panelH
						(click)="panelH._toggle()"
						(click)="onClickItem()"
						routerLinkActive="active-link"
						[routerLink]="menuitem.routerLink"
						[ngClass]="{ 'disabled-item': !menuitem.enable }"
						[ngClass]="{
							'active-menu': activeItem == menuitem.name
						}"
					>
						<mat-panel-title>
							<mat-icon>{{ menuitem.icon }}</mat-icon>
							{{ menuitem.title }}
						</mat-panel-title>
					</mat-expansion-panel-header>
				} @else {
					<mat-expansion-panel-header
						#panelH
						(click)="panelH._toggle()"
						(click)="onClickItem()"
						[ngClass]="{ 'disabled-item': !menuitem.enable }"
						[ngClass]="{
							'active-menu': activeItem == menuitem.name
						}"
					>
						<mat-panel-title>
							<mat-icon> {{ menuitem.icon }}</mat-icon>
							{{ menuitem.title }}
						</mat-panel-title>
					</mat-expansion-panel-header>
				}
			</mat-expansion-panel>
		</mat-accordion>
	} @else {
		<mat-accordion>
			<mat-expansion-panel
				[hideToggle]="!menuitem.subMenu"
				[ngStyle]="style"
				class="mat-elevation-z0"
				[ngClass]="{ 'disabled-item': !menuitem.enable }"
				[expanded]="open"
			>
				<mat-expansion-panel-header>
					<mat-panel-title>
						<mat-icon>{{ menuitem.icon }}</mat-icon>
						{{ menuitem.title }}
					</mat-panel-title>
				</mat-expansion-panel-header>

				@if (menuitem.subMenu && menuitem.subMenu.length > 0) {
					@for (menu of menuitem.subMenu; track menu.name) {
						<app-item-side-bar
							[menuitem]="menu"
							(itemClicked)="onClickSideItem($event)"
						></app-item-side-bar>
					}
				} @else {
					@if (menuitem.routerLink) {
						<mat-action-list>
							<button mat-list-item (click)="onClickItem()">
								{{ menuitem.routerLink }}
							</button>
						</mat-action-list>
					}
				}
			</mat-expansion-panel>
		</mat-accordion>
	}
}
